module.exports = __webpack_public_path__ + "static/img/logo40.d23095d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo40.png
// module id = yjNx
// module chunks = 1